<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="table-container">
      <div class="table-title">
        <div class="table-caption">
          当社の安全に対する姿勢
        </div>
        輸送の安全に関する
        基本的な指針
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              ①社長は、輸送の安全の確保が根幹であることを深く認識し、
                社員に輸送の安全の確保が最も重要であるという意識を徹底させ、
                また、社内において輸送の安全の確保に主導的な役割を果たす。
              ②安全マネジメントを確実に実施し、全社員が一丸となって業務を遂行することにより、
                絶えず輸送の安全性の向上に努める。
              ③輸送の安全に関する情報について、積極的に公表する。
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          安全に関する認証
        </div>
        日本バス協会認定
        「貸切バス事業者安全性評価認認定制度」
        （<a href="https://www.mlit.go.jp/jidosha/jidosha_tk3_000043.html">セーフティバス</a>） ★★★取得
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              この制度は貸切バス事業者の安全性や安全の確保に向けた取り組み状況について評価認定を行う制度で、平成23年度（2011）から開始されました。当社では平成23年（初年度）に認定を受け、同制度最高の3つ星を業界第1グループとして取得しました。貸切バス会社全国約 4,500社のうち認定事業者は1,431社(31.8%)、その中で★★★は347社(7.7%)、そして7年連続セーフティーバスは136社(3.0%)です。(H29年度認定時（H29.12.21))
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          安全に関する認証
        </div>
        公益社団法人全日本トラック協会
        「貨物自動車運送事業者安全性優良事業所認定」（<a href="https://www.mlit.go.jp/jidosha/jidosha_tk4_000013.html">Gマーク</a>）取得
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              この制度は国土交通大臣指定機関が法に規定する輸送の安全確保等に関する下記事項について充分に評価した事業所に認定するもので、同一法人であっても各事業所（営業所）毎に認定されます。 認定事業所は貨物運送事業社全国約84,604事業所のうち、24,482事業所(28.9%)です 認定事業者数は全事業者62,167事業者のうち10,993社（17.7%）です。（H29年度認定時（H29.12.14））
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title text">
        <div class="table-caption">
          過去10年間の事故に関する統計
        </div>
        過去10年間、事故件数は0件。（自動車事故報告規則第二条に基づく）
        引き続き当社は安全を追求します。
      </div>
      <table class="table">
        <tbody>
          <tr>
            <td class="text">
              令和02年7月～令和03年6月（当社令和02年度） ０件
              令和01年7月～令和02年6月（当社令和01年度） ０件
              平成30年7月～令和01年6月（当社平成30年度） ０件
              平成29年7月～平成30年6月（当社平成29年度） ０件
              平成28年7月～平成29年6月（当社平成28年度） ０件
              平成27年7月～平成28年6月（当社平成27年度） ０件
              平成26年7月～平成27年6月（当社平成26年度） ０件
              平成25年7月～平成26年6月（当社平成25年度） ０件
              平成24年7月～平成25年6月（当社平成24年度） ０件
              平成23年7月～平成24年6月（当社平成23年度） ０件
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="table-title">令和3年度の目標（令和3年7月~令和4年6月）</div>
      <table class="table">
        <tbody>
          <tr v-for="(goals, index) in goals" :key=index>
            <th>{{ goals.title }}</th>
            <td>{{ goals.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container last">
      <div class="table-title">令和2年度の目標達成結果（令和2年7月~令和3年6月）</div>
      <table class="table">
        <tbody>
          <tr v-for="(results, index) in results" :key=index>
            <th>{{ results.title }}</th>
            <td>{{ results.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'SAFETY',
      message: '世界一安全に大型輸送を行うために',
      goals: [
        { title: '（1）事故件数（自動車事故報告規則第2条に基づく事故）', content: '人身事故 / 物損事故 / 車両故障　0件 ' },
        { title: '（2）自動ブレーキまたは衝突警報＋車線逸脱警報装置装着比率', content: '貨物：90％\n旅客：小型バスを除く全車両に取付済み' },
        { title: '（3）運転者の運行管理者資格又は同補助者の資格取得', content: '旅客運転者の80％' },
        { title: '（4）新型コロナの影響により運転間隔が1週間以上空いた運転者に対して、週1回以上の運転訓練(10〜50km程度)を実施する。 \n※ 本年度も新型コロナウイルスの影響下にあるため、この方針は継続する。', content: '' },
        { title: '（5）運転技術向上のため、実車運転による技能訓練、実地訓練を実施する。\n（実車による狭路走行訓練、上高地等の危険箇所実地研修など）', content: '' }
      ],
      results: [
        { title: '（1）事故件数（自動車事故報告規則第2条に基づく事故）', content: '人身事故 / 物損事故 / 車両故障　0件（目標達成）' },
        { title: '（2）運転者の運行管理者資格又は同補助者の資格取得', content: '旅客運転者の69%（達成率87% 目標80%）' },
        { title: '（3）運転間隔が1週間以上空いた運転者に対して、週1回以上の運転訓練（10km～50km程度）を実施する。', content: '乗務のない場合、概ね1週間に一度、実車走行訓練を実施しました。（目標達成）' },
        { title: '（4）当分の間、旅客は2名乗務（1名は安全確認者）とする。', content: '一定期間、旅客の2名乗務を実施しました。それ以降については、（3）の走行訓練の実施により、1名乗務となりました。ただし、危険箇所走行や法令に基づく2名乗務の場合は2名乗務です。（目標達成）' }
      ]
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/safety.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  width: 40%;
  color: #000000;
}
.table th {
  color: #707F89;
}
.text {
  font-size: 20px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #6F6B6B;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Safety.vue